import React from 'react';
import { Button } from 'react-bootstrap5';

export default function Header() {
  return (
    <section>
      <div className="mb-3 row">
        <div className="col">
          <h1>Settings</h1>
        </div>
        <div className="col-auto">
          <Button className="d-none">Preview My Landing Page</Button>
        </div>
      </div>
    </section>
  );
}
